import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import AppAddPillButton from '../../../components/designe/buttons/app-add-pill-button/AppAddPillButton';
import PageContainer from '../../../components/layout/page-container/PageContainer';
import { useRegisterPageContainerError } from '../../../components/layout/page-container/page-container-error-handler';
import Search from '../../../components/reusable/search/Search';
import { useNavigationStack } from '../../../context/NavigationStackContext';
import { Paths } from '../../../shared/paths';
import { useStyles } from './BugReports.styles';
import BugReportItem from './bug-report-item/BugReportItem';
import { useBugReports } from './useBugReports';

export default function BugReports(props) {
  const { t, i18n } = useTranslation();
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const { navigate } = useNavigationStack();
  const { reports, refetch, isLoading, isFetching, isError, error } =
    useBugReports();
  const [filter, setFilter] = useState('');
  const filteredReports = useMemo(
    () =>
      reports?.filter((report) => {
        const value = filter.toLowerCase();
        return (
          report.title.toLowerCase().indexOf(value) !== -1 ||
          report.type?.name?.toLowerCase().indexOf(value) !== -1
        );
      }),
    [filter, reports],
  );

  function onNewReportButtonClick() {
    navigate(Paths.bugReports.toNew);
  }
  const handleRetry = useCallback(() => {
    void refetch();
  }, [refetch]);

  useRegisterPageContainerError({
    errors: isError && error ? [error] : [],
    isLoading: !reports && (isLoading || isFetching),
    hasData: Boolean(reports?.length),
    onRetry: handleRetry,
  });

  return (
    <PageContainer
      title={t('common.bugReports')}
      onRefresh={() => void refetch()}>
      <Box className={classes.bugReportsPageWrapper}>
        <Box display="flex" alignItems="flex-end" gap={1} marginTop={0.5}>
          <Search fullWidth value={filter} onChange={setFilter} />
          <AppAddPillButton onClick={() => onNewReportButtonClick()} />
        </Box>
        <Box className={classes.bugReportsListContainer}>
          {filteredReports?.map((report) => (
            <BugReportItem report={report} key={report.id} />
          ))}
        </Box>
      </Box>
    </PageContainer>
  );
}
